import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { LoginApiService } from '../api/login-api.service';
@Injectable({
    providedIn: 'root'
})
export class AuthGuardService {

    private readonly loginService = inject(LoginApiService);

    private readonly router = inject(Router);

    canActivate(): boolean| UrlTree {

        if (!this.loginService.isLoggedIn()) {
            return this.router.parseUrl('login');
        }

        return true;
    }
}
